import 'es5-shim/es5-shim.min.js';
import 'es5-shim/es5-sham.min.js';
import 'es6-shim/es6-shim.min.js';
import 'es6-shim/es6-sham.min.js';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';

/* Other libraries */
global.jQuery = require('jquery');
require('bootstrap');
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css';
import 'react-super-select/lib/react-super-select.css';

if(Array.prototype.includes === undefined) {
  // eslint-disable-next-line
  Array.prototype.includes = function(value) { return this.indexOf(value) !== -1 } // TODO: better way ???
}

ReactDOM.render(
  <App />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js